//General
export const ERROR = "ERROR";

//Login Actions
export const LOGGED_IN = "LOGGED_IN";
export const LOGGING_OUT = "LOGGING_OUT";
export const LOGGED_OUT = "LOGGED_OUT";
export const FAILED_TO_LOGIN = ERROR;
export const LOGGING_IN = "LOGGING_IN";

//Quote Actions
export const CREATE_QUOTE = "CREATE_QUOTE";
export const CREATED_QUOTE = "CREATED_QUOTE";
export const SELECTED_TERMS = "SELECTED_TERMS";
export const PREVIEW_QUOTE = "PREVIEW_QUOTE";
export const QUOTE_NAV_BACK = "NAV_BACK_CLICKED";
export const SEND_QUOTE_TO_CUSTOMER = "SEND_QUOTE_TO_CUSTOMER";
export const QUOTE_SENT = "QUOTE_SENT";
export const CANCELED_QUOTE = "CANCELED_QUOTE";
export const ERROR_SENDING_QUOTE = "ERROR_SAVING_QUOTE";
export const ERROR_CREATING_QUOTE = "ERROR_CREATING_QUOTE";


//Credit Actions
export const GO_TO_NEXT_CREDIT_STEP = "GO_TO_NEXT_CREDIT_STEP";
export const SEND_CREDIT_APPLICATION = "SEND_CREDIT_APPLICATION";

//Notifications
export const NOTIFY_CLOSE = "NOTIFY_CLOSE";
export const NOTIFY_NEW = "NOTIFY_NEW";

//Password Reset
export const RESET_PASSWORD = "RESET_PASSWORD";



// WEBPACK FOOTER //
// ./src/app/utils/ActionConstants.js